// // Wait for the DOM to be fully loaded
// document.addEventListener("DOMContentLoaded", function() {
//   // Get all the h3 elements
//   var acc = document.querySelectorAll("h3");

//   // Add a click event listener to each h3
//   acc.forEach(function(el) {
//       el.addEventListener("click", function() {
//           // Get the next sibling element
//           var panel = this.nextElementSibling;

//           // Check if the panel is already active
//           if (panel.style.display === "block") {
//               panel.style.display = "none";
//           } else {
//               panel.style.display = "block";
//           }
//       });
//   });
// });

// // エージェントによるイベント登録分岐
// //-------------------------------------------------
// if (typeof window !== `undefined`) {
//   // エージェントの時はこっち
//   if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
//     innerHeaderSpan.addEventListener("touchend", navButtonToggle);
//   } else {
//     innerHeaderSpan.addEventListener("mouseup", navButtonToggle);
//   }
// }

//--------------------

// メニュー項目内のspanタグを全て取得
const menuItemSpans = document.querySelectorAll(".es--table--accordion--wrap h3");

// spanタグのクリックイベントに対する関数
const toggleMenuItem = e => {
    // var panel = e.currentTarget.nextElementSibling;
    // // Check if the panel is already active
    // if (panel.style.display === "block") {
    //   panel.style.display = "none";
    // } else {
    //   panel.style.display = "block";
    // }
    // // // クリックされたspanタグの親要素（メニュー項目）を取得
    // var menuItem = e.currentTarget.nextElementSibling;
    const menuItem = e.currentTarget;

    // メニュー項目にアクティブクラスがあるか確認
    if (menuItem.classList.contains("inner--active")) {
        // アクティブクラスがあれば、クラスを除外
        menuItem.classList.remove("inner--active");
    } else {
        // アクティブクラスがなければ、クラスを追加
        menuItem.classList.add("inner--active");
    }
};

// エージェントによるイベント登録分岐
//-------------------------------------------------
if (typeof window !== `undefined`) {
    let device = "";
    // エージェントの時はこっち
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
        device = "touchend";
    } else {
        device = "mouseup";
    }
    // 各spanタグにクリックイベントリスナーを設定
    menuItemSpans.forEach(span => span.addEventListener(device, toggleMenuItem));
}

//# sourceURL=webpack://lp_create_kit/./src/js/table_accordion.js?